import * as tslib_1 from "tslib";
import { of, forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SweepOptionTypes } from '../sweep-options/sweep-option-types';
import { AppMessagesService } from '../app-messages/app-messages.service';
import { SweepOptionsService } from '../sweep-options/sweep-options.service';
import * as i0 from "@angular/core";
import * as i1 from "../sweep-options/sweep-options.service";
import * as i2 from "../app-messages/app-messages.service";
var AccountAdditionalInfoService = /** @class */ (function () {
    function AccountAdditionalInfoService(sweepOptionsService, appMessagesService) {
        this.sweepOptionsService = sweepOptionsService;
        this.appMessagesService = appMessagesService;
    }
    AccountAdditionalInfoService.prototype.getAdditionalSecondaryInfos = function (accountInfos) {
        var e_1, _a;
        if (!accountInfos || accountInfos.length === 0) {
            return of([]);
        }
        var accountAdditionalInfoObservableList = [];
        try {
            for (var accountInfos_1 = tslib_1.__values(accountInfos), accountInfos_1_1 = accountInfos_1.next(); !accountInfos_1_1.done; accountInfos_1_1 = accountInfos_1.next()) {
                var accountInfo = accountInfos_1_1.value;
                accountAdditionalInfoObservableList.push(this.getAdditionalSecondaryInfo(accountInfo));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (accountInfos_1_1 && !accountInfos_1_1.done && (_a = accountInfos_1.return)) _a.call(accountInfos_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return forkJoin(accountAdditionalInfoObservableList);
    };
    AccountAdditionalInfoService.prototype.getAdditionalSecondaryInfo = function (accountInfo) {
        var _this = this;
        var sweepOption = accountInfo ? accountInfo.sweepOption : null;
        return forkJoin(this.sweepOptionsService.getSweepOptionBySymbol(sweepOption), this.appMessagesService.getAppMessages()).pipe(switchMap(function (results) {
            var _a = tslib_1.__read(results, 2), sweepOptionInfo = _a[0], messageInfo = _a[1];
            return of({
                referenceId: accountInfo.referenceId,
                secondaryContractValues: _this.prepareAdditionalInfo(accountInfo, sweepOptionInfo, messageInfo)
            });
        }));
    };
    AccountAdditionalInfoService.prototype.prepareAdditionalInfo = function (accountInfo, sweepOptionInfo, messageInfo) {
        var additionalInfos = [];
        additionalInfos = additionalInfos.concat(this.prepareAccountYieldInfo(sweepOptionInfo, messageInfo));
        additionalInfos = additionalInfos.concat(this.prepareAccountPerformanceInfo(accountInfo, sweepOptionInfo, messageInfo));
        return additionalInfos;
    };
    AccountAdditionalInfoService.prototype.prepareAccountYieldInfo = function (sweepOptionInfo, messageInfo) {
        if (!sweepOptionInfo) {
            return [];
        }
        return this.prepareAccountYields(sweepOptionInfo, messageInfo);
    };
    AccountAdditionalInfoService.prototype.prepareAccountPerformanceInfo = function (accountInfo, sweepOptionInfo, messageInfo) {
        var interestYTD = accountInfo ? accountInfo.interestYTD : null;
        if (!interestYTD) {
            return [];
        }
        var accountPerformanceContent = this.prepareAccountPerformanceContent(sweepOptionInfo, messageInfo);
        return [
            {
                title: accountPerformanceContent.title,
                titleToolTip: {
                    title: accountPerformanceContent.title,
                    description: accountPerformanceContent.description
                },
                value: interestYTD ? this.formatAmountValue(interestYTD) : '',
                valueType: 'amount'
            }
        ];
    };
    AccountAdditionalInfoService.prototype.prepareAccountYields = function (sweepOptionInfo, messageInfo) {
        var _this = this;
        var yields = sweepOptionInfo.yield || [];
        var symbol = sweepOptionInfo.symbol;
        return yields.map(function (rawYield) {
            var yieldType;
            var defaultTitle;
            if (rawYield.durationUnit === 'day' && rawYield.duration === '365') {
                if (symbol === SweepOptionTypes.NFS_MM_FUND || symbol === SweepOptionTypes.PGIM_MM_FUND) {
                    yieldType = 'return_annual';
                    defaultTitle = '1 Year Return';
                }
                else {
                    yieldType = 'yield_annual';
                    defaultTitle = 'Annual Percentage Yield';
                }
            }
            else if (rawYield.durationUnit === 'day' && rawYield.duration === '7') {
                yieldType = 'yield_7_day';
                defaultTitle = '7 Day Yield';
            }
            else {
                defaultTitle = rawYield.duration + ' ' + rawYield.durationUnit + ' yield';
            }
            try {
                var yieldContent = messageInfo.common.messages[yieldType];
                return {
                    title: yieldContent.title,
                    titleDesc: 'As of ' + rawYield.asOfDate,
                    titleToolTip: {
                        title: yieldContent.title,
                        description: yieldContent.content
                    },
                    value: _this.formatAmountValue(rawYield.value),
                    valueType: 'percentage'
                };
            }
            catch (e) {
                return {
                    title: defaultTitle,
                    titleDesc: 'As of ' + rawYield.asOfDate,
                    titleToolTip: {
                        title: defaultTitle,
                        description: defaultTitle
                    },
                    value: _this.formatAmountValue(rawYield.value),
                    valueType: 'percentage'
                };
            }
        });
    };
    AccountAdditionalInfoService.prototype.prepareAccountPerformanceContent = function (sweepOptionInfo, messageInfo) {
        try {
            var sweepOption = (sweepOptionInfo && sweepOptionInfo.symbol) || null;
            var accountPerformanceContent = void 0;
            if (sweepOption) {
                sweepOption = 'interest_' + sweepOption.toLowerCase();
                accountPerformanceContent = messageInfo.common.messages[sweepOption];
            }
            accountPerformanceContent = accountPerformanceContent || messageInfo.common.messages.interest_ytd;
            return {
                title: accountPerformanceContent.title,
                description: accountPerformanceContent.content
            };
        }
        catch (e) {
            return {
                title: 'Income/Interest Earned YTD',
                description: 'Income/Interest Earned YTD'
            };
        }
    };
    AccountAdditionalInfoService.prototype.formatAmountValue = function (rawValue) {
        try {
            return parseFloat(rawValue).toFixed(2);
        }
        catch (e) {
            return rawValue;
        }
    };
    AccountAdditionalInfoService.ngInjectableDef = i0.defineInjectable({ factory: function AccountAdditionalInfoService_Factory() { return new AccountAdditionalInfoService(i0.inject(i1.SweepOptionsService), i0.inject(i2.AppMessagesService)); }, token: AccountAdditionalInfoService, providedIn: "root" });
    return AccountAdditionalInfoService;
}());
export { AccountAdditionalInfoService };
